// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".react-tel-input{width:100%}.react-tel-input .form-control{width:100%}", "",{"version":3,"sources":["webpack://./app/pages/components/contacts/Form/index.scss"],"names":[],"mappings":"AAAA,iBACE,UAAA,CAGF,+BACE,UAAA","sourcesContent":[".react-tel-input {\n  width: 100%;\n}\n\n.react-tel-input .form-control {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
